import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, euro, data, STATO_CARD } from "@/lib/api";
import { Page, Spinner } from "@/components/Layout";

export default function Account() {
  const [cards, setCards] = useState(null);
  useEffect(() => {
    api.get("/acquirente/giftcard").then((r) => setCards(r.data));
  }, []);
  if (!cards) return <Spinner />;
  return (
    <Page>
      <p className="caption">Il mio account</p>
      <h1 className="font-display text-4xl sm:text-5xl mt-2">Le mie gift card</h1>
      <p className="text-[#786E65] mt-2">Per motivi di sicurezza il codice completo non viene conservato: lo trovi nell'email e nel PDF ricevuti.</p>
      {cards.length === 0 ? (
        <div className="card mt-8 text-center py-12" data-testid="account-empty">Non hai ancora gift card. <Link to="/" className="text-[#7E5BAF] underline">Scopri il catalogo</Link></div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" data-testid="account-cards">
          {cards.map((c) => (
            <div key={c.id} className="card relative overflow-hidden" data-testid={`account-card-${c.id}`}>
              <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-[#C8A2E8]/15" />
              <div className="flex justify-between items-start">
                <p className="caption">{c.ricevuta ? "Ricevuta" : "Acquistata"}</p>
                <span className={STATO_CARD[c.stato]}>{c.stato}</span>
              </div>
              <p className="font-display text-2xl mt-3">{c.operatore}</p>
              <p className="font-display text-4xl text-[#7E5BAF] mt-2">{euro(c.saldo_cent)}</p>
              <p className="text-sm text-[#786E65]">su {euro(c.importo_cent)} · scade il {data(c.scadenza)}</p>
              <p className="font-code text-sm mt-3">{c.ultime4 ? `••••-••••-••••-${c.ultime4}` : `Consegna programmata il ${data(c.data_consegna)}`}</p>
              {!c.ricevuta && c.destinatario_email && <p className="text-xs text-[#786E65] mt-2">Per {c.destinatario_nome} ({c.destinatario_email})</p>}
            </div>
          ))}
        </div>
      )}
    </Page>
  );
}
